<div class="library-content-mini" [class.mobile]="isMobile">
  <div class="details">
    <div class="card-cover"></div>
    <div class="cover-wrap">
      <on-ui-cover [cover]="coverUrl"></on-ui-cover>
    </div>
    <div class="info-block">
      <div class="meta">
        <div class="subject">{{ content?.subject?.title }}</div>
        <a [routerLink]="contentUrl" class="title-wrap">
          <h5 class="title">{{ content?.title }}</h5>
        </a>
        <span class="content-type-and-level">{{ (contentTypeTitle | customLocale) + ', ' + (level | customLocale) }}</span>
        <ng-container *ngTemplateOutlet="statusBlock"></ng-container>
      </div>
      <div class="stats" *ngIf="!isMobile">
        <ng-container *ngTemplateOutlet="statsRef"></ng-container>
      </div>
    </div>
    <div class="actions" *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
    </div>
  </div>

  <div class="footer" *ngIf="isMobile">
    <div class="stats">
      <ng-container *ngTemplateOutlet="statsRef"></ng-container>
    </div>
    <div class="actions">
      <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
    </div>
  </div>
</div>

<ng-template #statsRef>
  <ng-template [ngIf]="isAvailableClickAndInfo">
  <div class="stats-item">
    <app-icon class="likes-icon" [class.active]="content?.visit_info && content?.visit_info.is_liked" icon="thumb-up"></app-icon>
    <span class="stats-label">{{ content?.stats.likes_count }}</span>
  </div>

  <div class="stats-item">
    <app-icon class="dislikes-icon" [class.active]="content?.visit_info && content?.visit_info.is_disliked" icon="thumb-down"></app-icon>
    <span class="stats-label">{{ content?.stats.dislikes_count }}</span>
  </div>

  <div class="stats-item">
    <app-icon class="views-icon" [class.active]="content?.visit_info && content?.visit_info.is_viewed" icon="shows"></app-icon>
    <span class="stats-label">{{ content?.stats.views_count }}</span>
  </div>
  </ng-template>
</ng-template>

<ng-template #actionsRef>
  <span *ngIf="canAction('view')"
        class="action"
        (click)="onOpenCardInModal()">{{ 'my-library.cards-actions.view' | customLocale }}</span>
  <span *ngIf="canAction('unpublish') && isAvailableClickAndInfo"
        class="action"
        (click)="checkContentStatusChange('unpublish')">{{ 'my-library.cards-actions.unpublish' | customLocale }}</span>
  <span *ngIf="canAction('edit')"
        class="action"
        (click)="onEditContent()">{{ 'my-library.cards-actions.edit' | customLocale }}</span>
  <span *ngIf="canAction('archive')"
        class="action"
        (click)="checkContentStatusChange('archive')">{{ 'my-library.cards-actions.archive' | customLocale }}</span>
  <span *ngIf="canAction('restore')"
        class="action"
        (click)="checkContentStatusChange('restore')">{{ 'my-library.cards-actions.restore' | customLocale }}</span>
</ng-template>

<ng-template #statusBlock>
  <div class="status" *ngIf="moderationStatus">
    <div class="status-block status-block__{{moderationStatus.value}}" *ngIf="moderationStatus.label">
      {{ moderationStatus.label | customLocale }}
    </div>
    <div class="reason-icon" *ngIf="content.moderation_message">
      <app-icon width="15" height="15" icon="question-service"></app-icon>
      <div class="reason-text">
        <p class="label">Причина:</p>
        <p class="text">{{content.moderation_message}}</p>
      </div>
    </div>
  </div>
</ng-template>

<app-status-change-alert *ngIf="isAlertOpened" [type]="alertType"  (closed)="onAlertCancel()" (save)="onStatusChange()"></app-status-change-alert>
